import { FC, useState } from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import { copyTextToClipboard } from '../../utils/utils';

type CopyIconButtonProps = {
    value: string | null | undefined;
} & Omit<IconButtonProps, 'value'>;

const CopyIconButton: FC<CopyIconButtonProps> = ({
    value,
    onClick,
    ...iconButtonProps
}) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = async (event: React.MouseEvent<HTMLButtonElement>) => {
        onClick?.(event);

        const succeeded = await copyTextToClipboard(value);

        if (succeeded) {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        }
    };

    return (
        <IconButton onClick={handleCopy} {...iconButtonProps}>
            <i
                className={
                    isCopied
                        ? 'fa-light fa-check'
                        : 'fa-light fa-copy'
                }
            />
        </IconButton>
    );
};

export { CopyIconButton };
